export const flickity = () => {
    $(document).ready(function () {
        let $imageSlider = $('.imageSlider');

        if ($imageSlider.count) {
            // Initialize flickity for .imageSlider
            $imageSlider.flickity({
                autoPlay: 3500,
                draggable: false,
                pauseAutoPlayOnHover: false
            });

            // Prevents carousel from pausing due to a click.
            $imageSlider.on('select.flickity', function () {
                $('.imageSlider').flickity('playPlayer')
            });
        }
    });
}
